export const styles = {
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "30px",
    marginBottom: "30px",
    width: "100%",
    textAlign: "center"
  },
  flexColumnContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    width: "auto",
    paddingTop: "40px",
    paddingLeft: "20px",
    fontFamily: "Helvetica, Arial, sans-serif",
    "@media (minWidth: 1024px)": {
      paddingTop: "12px",
      paddingLeft: 0
    }
  },
  headerContainer: {
    display: "flex",
    fontSize: "2em",
    justifyContent: "center",
    margin: "10px 0px 30px",
    fontFamily: "Helvetica, Arial, sans-serif",
    width: "100%",
    textAlign: "center"
  },
  headerWrapper: {
    display: "flex",
    width: "95%",
    maxWidth: "900px",
    /*marginBottom: '33px',*/
    flexDirection: "column",
    "@media (minWidth: 1024px)": {
      width: "90%"
    },
    "@media (minWidth: 1180px)": {
      flexDirection: "row"
    }
  },
  pageHeaderContainer: {
    fontSize: "1.4em",
    fontWeight: "bold",
    marginBottom: "33px"
  },
  pageHeaderWithExtrasContainer: {
    fontSize: "1.4em",
    fontWeight: "bold",
    marginBottom: "24px",
    display: "flex",
    flex: 2,
    "@media (minWidth: 1180px)": {
      marginBottom: "33px"
    }
  },
  extrasContainer: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "15px",
    "@media (minWidth: 600px)": {
      marginBottom: "33px",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center"
    }
  },
  subHeaderContainer: {
    display: "flex",
    width: "95%",
    maxWidth: "900px",
    marginBottom: "25px",
    fontSize: "13px",
    marginTop: "-15px",
    fontStyle: "italic",
    "@media (minWidth: 1024px)": {
      width: "90%"
    }
  },
  container: {
    display: "flex",
    flexDirection: "column",
    fontFamily: "Helvetica, Arial, sans-serif",
    justifyContent: "center",
    margin: "0 auto",
    width: "90%",
    "@media (minWidth: 768px)": {
      width: "75%"
    },
    "@media (minWidth: 1024px)": {
      width: "50%"
    }
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    fontSize: "16px",
    width: "95%",
    maxWidth: "900px",
    "@media (minWidth: 1024px)": {
      width: "90%"
    }
  },
  linkStyle: {
    color: "#3b5998",
    textDecoration: "underline",
    fontSize: "12px",
    margin: "10px 0px",
    cursor: "pointer",
    ":hover": {
      color: "#3a56ff"
    }
  },
  listLinkStyle: {
    paddingRight: "5px",
    color: "#3b5998", // '#7a1317',
    textDecoration: "underline",
    fontSize: "12px",
    cursor: "pointer",
    ":hover": {
      color: "#3a56ff"
    }
  },
  feedbackTextContainer: {
    display: "flex",
    justifyContent: "left",
    margin: "30px 0px",
    fontWeight: "bold",
    fontSize: "14px"
    // color: '#7a1317'
  },
  textContainer: {
    display: "flex",
    margin: "5px 0px 20px", // marginBottom: 30
    fontSize: 14
  },
  sendButtonContainer: {
    display: "flex",
    flexGrow: "1",
    justifyContent: "flex-start"
  },
  goBackButtonContainer: {
    display: "flex",
    flexGrow: "1",
    flexBasis: "0",
    justifyContent: "flex-end"
  },
  buttonContainer: {
    display: "flex"
    /*justifyContent: 'flex-end',
    padding: '10px 0px'*/
  },
  navButton: {
    cursor: "pointer",
    fontSize: "14px",
    display: "block",
    padding: "15px 20px",
    lineHeight: "1.5",
    border: "none",
    marginBottom: "1px",
    textAlign: "center",
    textDecoration: "none",
    fontFamily: "Helvetica, Arial, sans-serif",
    width: "100%",
    color: "#fff",
    fontWeight: "bold",
    backgroundColor: "#444",
    ":hover": {
      backgroundColor: "#555",
      textDecoration: "underline"
    }
    /*'@media (minWidth: 768px)': {
        padding: '10px 15px'
    }*/
  },
  okButton: {
    cursor: "pointer",
    width: "auto",
    fontSize: "14px",
    display: "block",
    padding: "10px 8px",
    "@media (minWidth: 360px)": {
      padding: "10px 15px"
    },
    "@media (minWidth: 480px)": {
      padding: "15px 15px"
    },
    "@media (minWidth: 501px)": {
      padding: "15px 20px"
    },
    lineHeight: "1.5",
    border: "none",
    marginBottom: "1px",
    textAlign: "center",
    textDecoration: "none",
    fontFamily: "Helvetica, Arial, sans-serif",
    color: "#fff",
    fontWeight: "bold",
    backgroundColor: "#016a29",
    ":hover": {
      backgroundColor: "#017f31",
      textDecoration: "underline"
    }
  },
  cancelButton: {},
  headerRow: {
    backgroundColor: "#eee",
    color: "#333",
    fontWeight: "bold",
    padding: "5px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#ddd",
    display: "flex",
    height: "20px",
    alignItems: "center",
    fontSize: "13px",
    "@media (minWidth: 600px)": {
      fontSize: "16px"
    },
    "@media (minWidth: 1024px)": {
      padding: "15px 20px",
      alignItems: "left"
    }
  },
  noData: {
    fontSize: "13px",
    fontStyle: "italic",
    padding: "15px 5px",
    "@media (minWidth: 1024px)": {
      padding: "15px 20px"
    }
  },
  row: {
    display: "flex",
    padding: "5px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: "#ddd",
    borderTop: "none",
    backgroundColor: "#fff",
    fontSize: "13px",
    minHeight: "25px",
    height: "auto",
    alignItems: "center",
    "@media (minWidth: 1024px)": {
      padding: "10px 20px",
      alignItems: "left"
    }
  },
  listItem: {
    display: "flex",
    width: "40%",
    flex: "2",
    alignItems: "left"
  },
  subItem: {
    display: "flex",
    flexDirection: "column",
    width: "100%"
  },
  subItemInfo: {
    color: "#999",
    fontSize: "13px",
    display: "none",
    "@media (minWidth: 600px)": {
      display: "inline"
    }
  },
  paginateWrapper: {
    display: "flex",
    marginBottom: "10px",
    "@media (minWidth: 1024px)": {
      marginBottom: 0
    }
  },
  paginateLink: {
    display: "flex",
    alignSelf: "flex-end",
    alignItems: "center",
    fontSize: 12,
    cursor: "pointer",
    height: 31
  },
  paginateLinkItem: {
    textDecoration: "underline",
    marginLeft: 3,
    color: "#3b5998"
  },
  paginateLinkSymbol: {
    fontSize: 16,
    color: "#3b5998"
  }
};
